class StoreCheckDelegate {}

export default StoreCheckDelegate;
